import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import ProductDetails from "../components/product/ProductDetails";
import Footer from "../components/layout/Footer";
import Header from "../components/layout/Header";
import { productData } from "../static/data";

const ProductDetailsPage = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [searchParams] = useSearchParams();
//   const eventData = searchParams.get("isEvent");

//   setData(productData.find((i) => i.id === id));

  return (
    <>
      <Header />
      <ProductDetails data={data} />
      {/* {
          !eventData && (
            <>
            {data && <SuggestedProduct data={data} />}
            </>
          )
        } */}
      <Footer />
    </>
  );
};

export default ProductDetailsPage;
